<template>
  <v-card>
    <v-card-title>料金</v-card-title>

    <v-card-text>
      <confirm-item label="基本料金" :charge="bookCharge.basic"/>
      <confirm-item label="追加料金" :charge="bookCharge.additional"/>
      <confirm-item label="割引" :charge="-bookCharge.discount"/>
      <hr>
      <confirm-item em label="合計 (税込)" :charge="bookCharge.total"/>

      <div class="guide mt-3 body-2 px-2">
        <p v-if="bookCharge.paymethod === PAY_SPOT">料金はお引渡しの際、店頭にてお支払い下さい。</p>
        <p v-else>料金はクレジットカードからお支払い頂きます。</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import PartBase from '@/mixins/PartBase'
import ConfirmItem from './ConfirmItem'
import * as C from '@/app/special/consts'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmCharge',
  mixins: [
    PartBase
  ],
  components: {
    ConfirmItem
  },
  data: () => ({
    PAY_SPOT: C.PAY_SPOT,
    PAY_CARD: C.PAY_CARD
  }),
  computed: {
    ...mapGetters('book', [
      'bookCharge'
    ])
  }
}
</script>
